<template>
  <div>
    <el-container>
      <!-- 学员上麦区域 -->
      <el-header v-if="ifHeadShow" height="300px" >
        <div v-for="(userInfo,userIndex) in userList" :key="userIndex" v-if="userInfo.ifSubscribed" style="height:300px;width:250px;">
          <div>{{userInfo.displayName}}</div>
          <video id="screenId" :ref="'subVideo_'+userInfo.userId" autoplay playsinline controls="controls" style="height:250px;width:250px;"></video>
        </div>
      </el-header>
      <el-container>
        <!-- 屏幕分享区域 -->
        <el-aside width="70%">
          <video ref="screenId" autoplay playsinline controls="controls"></video>
          <div v-if="userType==1" style="margin-top:20px;">
            <button @click="cameraPublisher()">{{cameraPublisherName}}</button>
            <button @click="screenPublish()">{{screenPublishName}}</button>
          </div>
        </el-aside>
        <!-- 右侧 视频区域+用户列表 -->
        <el-main>
          <el-container>
              <el-header height="200px">
                <!-- 视频流区域 -->
                <video ref="previewId" autoplay playsinline controls="controls" style="height:150px;width:150px;"></video>
              </el-header>
              <el-main>
                <el-tabs type="border-card">
                  <el-tab-pane label="听课学员">
                    <el-dropdown v-for="(userInfo,userIndex) in userList" :key="userIndex" @visible-change="(state)=>changeUserMenu(state,userInfo)" @command="(type)=>clickMenuOne(userInfo,type)" >
                      <span class="el-dropdown-link">
                        {{userInfo.displayName}}<i class="el-icon-arrow-down el-icon--right"></i>
                      </span>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="1">{{userInfo.ifSubscribed?'取消订阅':'订阅'}}</el-dropdown-item>
                        <el-dropdown-item command="2">取消订阅</el-dropdown-item>
                        <el-dropdown-item command="3">点赞</el-dropdown-item>
                        <el-dropdown-item command="4">打赏</el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </el-tab-pane>
                  <el-tab-pane label="聊天室">
                    
                  </el-tab-pane>
                  <el-tab-pane label="评价教师">评价教师</el-tab-pane>
                </el-tabs>
              </el-main>
          </el-container>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>
<script>
import jquery from 'jquery';
import './css/index.css';
import './js/jquery.min.js';
import './js/aliyun-webrtc-sdk-1.12.1.js';
import {sha256} from './js/sha256.js';
import {getSubscribeInfo, setConfigRemote, showAlert} from './js/utils.js';
export default {
  name: 'LiveRoom',
  data() {
    return {
      //直播间 房间号
      channelId : "12345",
      //userId
      // 进入人的userId
      userId:0,
      // 进入人的userName
      userName:"",
      userType:1,
      //房间的房主的 roomUserId
      roomUserId:'',
      aliWebrtc : new AliRtcEngine(),
      //直播间的用户列表
      userList : [],
      //推流列表
      publisherList : [],
      cameraPublisherName:"推视频流",
      screenPublishName:"屏幕分享",
      ifHeadShow:false
    };
  },
  props: {
    initRoomId:{
      type : Number,
      default : null
    }
  },
  created() {
    var that = this;
    var paramsJson = that.$route.query;
    if(paramsJson.roomId) {
      that.channelId = paramsJson.roomId;
      that.userType = paramsJson.userType;
      that.userId = paramsJson.userId;
      that.userName = paramsJson.userName;
      that.roomUserId = paramsJson.roomUserId;
    }
    if(that.initRoomId) {
      that.channelId = that.initRoomId;
    }
    that.aliWebrtc.configLocalAudioPublish = false;
    that.aliWebrtc.configLocalCameraPublish = false;
    that.aliWebrtc.isSupport().then(re => {
      // 初始化房间信息
      that.initRoom();
      // 进入房间
      that.joinRoom();
    }).catch(error => {
        alert("---"+error.message);
    })
  },
  mounted() {
    
  },
  components: {

  },
  methods: {
    /**
     * 加入房间
     */
    joinRoom:function() {
      var that = this;
      var userName = that.userName;
      var channelId = that.channelId;
      var aliWebrtc = that.aliWebrtc;
      
      //2. 获取频道鉴权令牌参数 为了防止被盗用建议该方法在服务端获取
      var authInfo = that.GenerateAliRtcAuthInfo(channelId);
      //3. 加入房间 默认推音频视频流
      aliWebrtc.joinChannel(authInfo, userName).then(() => {
        showAlert( "加入房间成功", "success");
        //非主播(教师) 角色进入 默认订阅 教师的 视频流 和屏幕共享流
        if(that.userType != 1) {
          that.receiveRoomVideo();
        }
        //教师进入 默认订阅 教师的屏幕共享流

      }).catch((error) => {
          showAlert("[加入房间失败]" + error.message, "danger");
      })
    },
    /**
     * 订阅房间 房主的视频流信息
     */
    receiveRoomVideo:function(){
      var that = this;
      var aliWebrtc = that.aliWebrtc;
      let userInfo = aliWebrtc.getUserInfo(that.roomUserId+"");//{userId:that.roomUserId}
      console.log("roomUserInfo=========================",userInfo,that.roomUserId);
      if(userInfo == null) {
        setTimeout(() => {
          that.receiveRoomVideo();
        },1000);
      } else {
        that.receivePublishManual(userInfo,3).then(re => {
          that.creatDomAndshowRemoteVideo(userInfo,3);
          that.creatDomAndshowRemoteVideo(userInfo,4);
          console.log("订阅房主成功");
        });
      }
    },
    /**
     * 推视频流
     */
    cameraPublisher:function(){
      var that = this;
      var aliWebrtc = this.aliWebrtc;
      if(aliWebrtc.configLocalAudioPublish) {
        aliWebrtc.configLocalAudioPublish = false;
        aliWebrtc.configLocalCameraPublish = false;
        this.cameraPublisherName = "推视频流";
        //如果是老师  关闭本地预览
        that.openClosePreview(2);
      } else {
        aliWebrtc.configLocalAudioPublish = true;
        aliWebrtc.configLocalCameraPublish = true;
        this.cameraPublisherName = "推流中";
        //如果是老师 开启本地预览
        that.openClosePreview(1);
      }
      aliWebrtc.publish().then((res) => {
      }, (error) => {
        showAlert("[推流失败]" + error.message, "danger");
        if(!aliWebrtc.configLocalAudioPublish) {
          this.cameraPublisherName = "推视频流";
        }
      });
    },
    /**
     * 开启或关闭本地预览
     */
    openClosePreview:function(type){
      var that = this;
      if(that.userType == 1) {
        var aliWebrtc = that.aliWebrtc;
        var previewVideo = that.$refs.previewId;
        if(type==1) {
          console.log("previewVideo=======================",previewVideo);
          aliWebrtc.startPreview(previewVideo).then((obj) => {
            console.log("obj===================",obj);
          }).catch((error) => { 
            showAlert("[开启预览失败]" + error.message,"danger");
          });
        } else {
            aliWebrtc.stopPreview().then((re) => {
            }).catch((error) => { 
                showAlert("[开启预览失败]" + error.message, "danger"); 
            });
        }
        
      }
    },
    /**
     * 屏幕分享
     */
    screenPublish:function(){
      var aliWebrtc = this.aliWebrtc;
      console.log("");
      if(aliWebrtc.configLocalScreenPublish) {
        aliWebrtc.configLocalScreenPublish = false;
        this.screenPublishName = "屏幕分享";
      } else {
        aliWebrtc.configLocalScreenPublish = true;
        this.screenPublishName = "屏幕分享中";
      }
      aliWebrtc.publish().then((res) => {
      }, (error) => {
        showAlert("[推流失败]" + error.message, "danger");
        if(!aliWebrtc.configLocalScreenPublish) {
          this.cameraPublisherName = "屏幕分享";
        }
      });
    },
    /**
     * 切换 菜单
     */
    changeUserMenu:function(state,userInfo){
      console.log("changeUserMenu==============state==============",state,userInfo);
    },
    /**
     * 点击菜单项
     */
    clickMenuOne:function(userInfo,type){
      console.log("clickMenuOne==============menuOne==============",userInfo,type);
      // 订阅
      if(type == 1) {
        this.unSub(userInfo,type);
      } 
    },
    /**
     * 订阅和取消订阅的方法 学生进来 默认订阅老师  老师可以选择打开那个学生的摄像头
     */
    unSub:function(userInfo,type) {
      var that = this;
      userInfo.ifSubscribed = !userInfo.ifSubscribed;
      if(userInfo.ifSubscribed) {
        that.ifHeadShow = true;
        that.receivePublishManual(userInfo,type).then(re => {
          that.creatDomAndshowRemoteVideo(userInfo,type);
          console.log("订阅成功");
        });
      } else {
        that.setConfigRemote(userInfo.userId, type).then(re => {
          console.log("取消订阅");
        });
      }
    },
    /**
     * 订阅设置
     */
    receivePublishManual:function(userInfo,type) {
      var aliWebrtc = this.aliWebrtc;
      console.log("receivePublishManual订阅", userInfo,type);
      return new Promise((resolve, reject) => {
          if (type == 1 || type == 3) {
              console.log("订阅固定视频流");
              aliWebrtc.configRemoteCameraTrack(userInfo.userId, true, true);
              aliWebrtc.configRemoteAudio(userInfo.userId, true);
          }
          if (type == 2 || type == 3) {
              console.log("订阅屏幕共享流");
              aliWebrtc.configRemoteScreenTrack(userInfo.userId, true);
          } 
          aliWebrtc.subscribe(userInfo.userId).then(re => {
              resolve();
          }).catch((error) => {
              reject(error);
              showAlert("[subscribe失败]" + error.message, "danger");
          });
      })
    },
    /**
     * 创建上麦学员的dom节点
     */
    creatDomAndshowRemoteVideo:function(userInfo,type) {
      var aliWebrtc = this.aliWebrtc;
      if (type == 1) {
        var dom = this.$refs['subVideo_'+userInfo.userId][0];
        aliWebrtc.setDisplayRemoteVideo(userInfo.userId, dom, 1);
      } else if(type == 2) {
        var dom = this.$refs['subVideo_'+userInfo.userId][0];
        aliWebrtc.setDisplayRemoteVideo(userInfo.userId, dom, 2);
      } else if(type == 3) {
        var dom = this.$refs.previewId;
        aliWebrtc.setDisplayRemoteVideo(userInfo.userId, dom, 1);
        console.log("dom==========333===========",dom);
        dom.play();
        setTimeout(() => {
          dom.play();
        },1000);
      } else if(type == 4) {
        var dom = this.$refs.screenId;
        aliWebrtc.setDisplayRemoteVideo(userInfo.userId, dom, 2);
        console.log("dom==========444===========",dom);
        dom.play();
        setTimeout(() => {
          dom.play();
        },1000);
      }
    },
    /**
     * 取消订阅
     */
    setConfigRemote:function (userId, type) {
      var aliWebrtc = this.aliWebrtc;
        return new Promise((resolve, reject) => {
            //demo中只订阅大流
            if (type == 1) {
                aliWebrtc.configRemoteCameraTrack(userId, false, false);
                aliWebrtc.configRemoteAudio(userId,false);
            } else if (type == 2) {
                aliWebrtc.configRemoteScreenTrack(userId, false);
            }
            aliWebrtc.subscribe(userId).then(re => {
                resolve();
            }).catch(error => console.log("取消订阅失败", error))
        });
    },
    GenerateAliRtcAuthInfo:function(){
      var that = this;
      var channelId = that.channelId;
      var appId = "uocfqy3z";// 修改为自己的appid 该方案仅为开发测试使用，正式上线需要使用服务端的AppServer
      var appKey = "b62bdee5a06e94070aa1d52b8c6d76fe";// 修改为自己的appkey 该方案仅为开发测试使用，正式上线需要使用服务端的AppServer
      if(!that.userId) {
        that.userId = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });// 可以自定义
      }
      var timestamp = parseInt(new Date().getTime() / 1000 + 48 * 60 * 60);
      var nonce = 'AK-' + timestamp;
      var token = sha256(appId + appKey + channelId + that.userId + nonce + timestamp);
      return {
          appid:appId,
          userid:that.userId+"",
          timestamp:timestamp,
          nonce:nonce,
          token:token,
          gslb: ["https://rgslb.rtc.aliyuncs.com"],
          channel:channelId
      };
    },
    initRoom:function(){
      var that = this;
      var aliWebrtc = this.aliWebrtc;
      /**
       * remote用户加入房间 onJoin
       * 更新在线用户列表
       */ 
      aliWebrtc.on("onJoin", (publisher) => {
          if(publisher.userId){
              let userList = aliWebrtc.getUserList();
              console.log("userList====================================",userList);
              userList.forEach((userOne)=>{
                userOne.ifSubscribed = false;
              })
              that.userList = userList;
          }
          //重置订阅状态
          //默认订阅远端音频和视频大流，但需要调用subscribe才能生效
          //这里取消默认订阅，根据需求进行订阅
          // aliWebrtc.configRemoteAudio(publisher.userId, false);
          // aliWebrtc.configRemoteCameraTrack(publisher.userId, false, false);
          // showAlert(publisher.displayName + "加入房间","success");
          console.log(publisher.displayName + "加入房间");
      });
      /**
       * remote流发布事件 onPublish
       * 将该用户新增到推流列表
       * 若该用户已存在推流列表，则进行状态更新
       */
      aliWebrtc.on("onPublisher", (publisher) => {
          console.log("onPublisher", publisher);
          if(publisher.userId == that.roomUserId) {
            that.receiveRoomVideo();
          }
          // let index = that.publisherList.getIndexByProprety(publisher.userId, "userId");
          // if (index === -1) {
          //     //新增
          //     that.publisherList.push(publisher);
          // } else {
          //     //流状态更新
          //     that.updatePublisherStream(publisher, index);
          // }
      });

      /**
       * remote流结束发布事件 onUnPublisher
       * 推流列表删除该用户
       * 移除用户视图
       * 初始化订阅状态
       */ 
      aliWebrtc.on("onUnPublisher", (publisher) => {
          console.log("onUnPublisher",publisher);
          detelePublisher(publisher.userId);
          initialization(publisher.userId);
      });

      /**
       * 被服务器踢出或者频道关闭时回调 onBye
       */
      aliWebrtc.on("onBye",(message) =>{
          //1:被服务器踢出
          //2:频道关闭
          //3:同一个ID在其他端登录,被服务器踢出
          var msg;
          switch (message.code) {
              case 1: msg = "被服务器踢出";
                  break;
              case 2: msg = "频道关闭";
                  break;
              case 3: msg = "同一个ID在其他端登录,被服务器踢出";
                  break;
              default: msg = "onBye";
          }
          showAlert(msg,"danger");
      });
      
      /**
       *  错误信息
       */ 
      aliWebrtc.on("onError", (error) => {
          console.log(error)
          var msg = error && error.message ? error.message : error;
          if (msg && msg.indexOf("no session") > -1) {
              msg = "请重新登录：" + msg;
          }
          if (error.errorCode === 10011 || error.errorCode === 10012) {
              msg = error.errorCode === 10011 ? "屏幕共享被禁止" : "屏幕共享已取消";
              that.screenPublishName = "屏幕分享";
          }

          if(error.code == 15) {
              msg = "没有开启H5兼容";
          }
          if(error.type === "publish") {
              // 提示用户网络状态不佳 
              console.log("推流断开 需要停止推流,然后重新推流");
              // 先记录当前推流状态
              var pubAudio = aliWebrtc.configLocalAudioPublish;
              var pubCamera = aliWebrtc.configLocalCameraPublish;
              var pubScreen = aliWebrtc.configLocalScreenPublish;
              // 设置取消推流
              aliWebrtc.configLocalAudioPublish = false;
              aliWebrtc.configLocalCameraPublish = false;
              aliWebrtc.configLocalScreenPublish = false;
              aliWebrtc.publish().then(()=>{
                  console.log("推流断开取消推流成功");
                  aliWebrtc.configLocalAudioPublish = pubAudio;
                  aliWebrtc.configLocalCameraPublish = pubCamera;
                  aliWebrtc.configLocalScreenPublish = pubScreen;
                  aliWebrtc.publish().then(()=>{
                      console.log("推流断开重新推流成功");
                  }).catch(err => {
                      console.log("推流断开重新推流失败");
                  })
              }).catch(err => {
                  console.log("推流断开取消推流失败");
              })
          }
          if(error.type === "subscribe") {
              console.log("订阅断开 取消订阅该userId的所有订阅并移除所有该userId的dom");
              //先记录当前用户的订阅状态
              var subInfo = getSubscribeInfo(error.userId);
              //取消订阅状态
              initialization(error.userId);
              aliWebrtc.subscribe(error.userId).then(re => {
                  console.log("订阅断开 取消订阅成功");
                  aliWebrtc.configRemoteAudio(error.userId,subInfo.isSubAudio);
                  aliWebrtc.configRemoteCameraTrack(error.userId,subInfo.isSubLarge,subInfo.isSubCamera);
                  aliWebrtc.configRemoteScreenTrack(error.userId,subInfo.isSubScreen);
                  aliWebrtc.subscribe(error.userId).then(re => {
                      console.log("订阅断开 重新订阅成功")
                      // if($("#" + error.userId + "_camera")){
                          // aliWebrtc.setDisplayRemoteVideo(error.userId,$("#" + error.userId + "_camera video")[0], 1)
                      // }
                      // if($("#" + error.userId + "_screen")){
                          // aliWebrtc.setDisplayRemoteVideo(error.userId,$("#" + error.userId + "_screen video")[0], 2)
                      // }
                  }).catch(err=>{
                      console.log("订阅断开 重新订阅失败");
                      detelePublisher(error.userId);
                  })
              }).catch(err => {
                  console.log("订阅断开 取消订阅失败", err)
                  detelePublisher(error.userId);
              });
          }
          showAlert(msg,"danger")
      });

      /**
       * 检测到用户离开频道 
       * 更新用户列表 
       * 移除用户视图
       */ 
      aliWebrtc.on("onLeave", (publisher) => {
          initialization(publisher.userId);
          // updateUserList();
          let userList = aliWebrtc.getUserList();
          that.userList = userList;
          showAlert(publisher.displayName + "离开房间","success");
      })
    },
    /**
     * 推流信息停止时  从订阅流中进行删除
     */
    detelePublisher:function(userId){
      let index = this.publisherList.getIndexByProprety(userId, "userId");
      if (index != -1) {
        publisherList.splice(index, 1);
        this.detelePublisher(userId);
      } else {
        console.log("未找到之前的推流数据"); //删除推流用户
      }
    },
    /**
     *  初始化订阅状态
     */
    initialization:function(userId){
      var aliWebrtc = this.aliWebrtc;
      if (aliWebrtc) {
        aliWebrtc.configRemoteAudio(userId, false);
        aliWebrtc.configRemoteCameraTrack(userId, false, false);
        aliWebrtc.configRemoteScreenTrack(userId, false);
      }
    },
    updatePublisherStream:function(publisher,index){
      var that = this;
      var publisherList = that.publisherList;
      let oldStreamConfigs = JSON.parse(JSON.stringify(publisherList[index].streamConfigs));
      let newStreamConfigs = publisher.streamConfigs;
      let subscribeInfo = getSubscribeInfo(publisher.userId);
      oldStreamConfigs.forEach((v, i, a) => {
        let newStream = newStreamConfigs.getObjByProprety(v.label, "label");
        // 判断流状态改变了 但不确定我们是否订阅了该流
        if (v.state != newStream.state) {
          console.log("流的状态变了" + v.label, v, v.type, ">"+ v.state + ">>" + newStream.state + ">", newStream, subscribeInfo);
          //并且要取消订阅某个流，不然就不能再次订阅了
          subscribeInfo.subscribeInfoArr.forEach(sv => {
            if (v.label === sv.label) {
              console.log("setConfigRemote取消订阅调用[api]:subscribe", publisher.userId, sv.type, sv.label);
              setConfigRemote(publisher.userId, sv.type, sv.label).then(re => {
                // 移除dom
                removeDom(publisher.userId, v.label);
              }).catch(error => {
                  console.error("流的状态变了重新订阅出问题", error);
              });
            }
          });
        }
      });
      publisherList.splice(index, 1, publisher);
    }
  }
}
        
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
